import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
// components
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export default function AuthHelpLink({ sx, ...other }) {
    const handleClick = () => {
        window.open('https://krmsoft.in/support/field_hrm.krmsoft_support', '_blank', 'noopener,noreferrer');
    };

    return (
        <Button
            variant="text"
            color="inherit"
            onClick={handleClick}
            startIcon={<Iconify icon="solar:headphones-round-sound-bold" width={20} />}
            sx={{
                mt: 3,
                color: 'text.secondary',
                fontWeight: 600,
                fontSize: '0.875rem',
                textTransform: 'none',
                '&:hover': {
                    color: 'text.primary',
                    bgcolor: 'action.hover',
                },
                ...sx
            }}
            {...other}
        >
            Support
        </Button>
    );
}

AuthHelpLink.propTypes = {
    sx: PropTypes.object,
};
